export default Object.freeze({
  TENANT_PROFILE: {
    TITLE: 'Convert to Individual Profile',
    MODAL_TITLE: 'Convert Profile From Business to Individual',
    DESC: 'Converting profile from business to a individual requires the following information.',
    CONFIRMATION_TEXT: 'Are you sure you want to convert profile from a business to a individual? If so, please ensure a new lease is issued to tenant with updated tenant information.'
  },
  BUSINESS_PROFILE: {
    TITLE: 'Convert to Business Profile',
    MODAL_TITLE: 'Convert Profile From Individual to Business',
    DESC: 'Converting profile from individual to a business requires the following information.',
    CONFIRMATION_TEXT: 'Are you sure you want to convert profile from a individual profile to a business? If so, please ensure a new lease is issued to tenant with updated tenant information.',
    CONFIRMATION_DESC: 'This will delete all of the business information.'
  },
  TENANT_FLAGS: {
    DO_NOT_RENT: 'do_not_rent',
  },
  DNR: {
    TEXT: 'Tenant is in Do Not Rent List so the Move-in is disabled.',
    EMAIL_TOOLTIP: 'Tenant is in Do Not Rent List so editing the Email is disabled.',
    PHONE_TOOLTIP: 'Tenant is in Do Not Rent List so editing the Phone is disabled.',
    AC_EMAIL_TOOLTIP: 'Alternate Contact is in Do Not Rent List so editing the Email is disabled.',
    AC_PHONE_TOOLTIP: 'Alternate Contact is in Do Not Rent List so editing the Phone is disabled.',
    TRANSFER_TOOLTIP: 'Tenant is in the Do Not Rent list so the transfer unit is disabled.',
    PROFILE_CONVERSION_TOOLTIP: 'Tenant is in the Do Not Rent list so Profile Conversion is disabled.'
  },
  DNR_MODEL: {
    MOVE_IN: 'The contact you are attempting to move in has been placed on the Do Not Rent list.',
    DNR_LIST: {
      NON_DNR_HARD_MATCHS_FOUND: { PRIMAY_CONTENT: '', SECONDARY_CONTENT: `The entered contact's info matches the following contacts and all will be added to Do Not Rent List:`, CONFIRMATION_TEXT: '' },
      NON_DNR_SOFT_MATCHS_FOUND: { PRIMAY_CONTENT: '', SECONDARY_CONTENT: `Please select the contacts to add to the Do Not Rent list from the list below:`, CONFIRMATION_TEXT: '' },
      DNR_MATCH_FOUND: { PRIMAY_CONTENT: '', SECONDARY_CONTENT: 'Matches found are already on the Do Not Rent list. No further action is required.', CONFIRMATION_TEXT: '' },
      NO_MATCH_FOUND: { PRIMAY_CONTENT: 'No matches found, adding it as new contact to Do Not Rent List. Are you sure you want to add it?', SECONDARY_CONTENT: '', CONFIRMATION_TEXT: '' },
    }
  }
});
